export const BaseDict = {
    NoMarketsAvailable: "No markets Available"
};
//# sourceMappingURL=dict.js.map